module.exports = __webpack_public_path__ + "media/MRI16B.88091706.mp3";